<template>
  <div class="home">
    <el-card class="box-card home-card">
      <div slot="header" class="clearfix">
        <el-carousel height="120px" class="hidden-sm-and-down">
          <el-carousel-item>
            <a
              href="https://www.wch.cn/products/CH585.html?from=BBS_Banner"
              target="_blank"
            >
              <img
                src="https://img.wch.cn/uploads/image/20250218/ztHEWriW6DMGDHvQX4m0SmIuoNlp9b3Dtvo7FZfb.png"
                alt="..."
              />
            </a>
          </el-carousel-item>
          <el-carousel-item>
            <a
              href="https://www.wch.cn/products/CH394.html?from=BBS_Banner"
              target="_blank"
            >
              <img
                src="https://img.wch.cn/uploads/image/20250218/g2JS6HVGv1pNeR4Rj7HgIKzOQWe6Ca7l1EQ8Fz9K.png"
                alt="..."
              />
            </a>
          </el-carousel-item>
        </el-carousel>
        <el-carousel class="carousel_mobile hidden-sm-and-up">
          <el-carousel-item>
            <a
              href="https://www.wch.cn/products/CH585.html?from=BBS_Banner"
              target="_blank"
            >
              <img src="https://img.wch.cn/20250210/02.png" alt="..." />
            </a>
          </el-carousel-item>
          <el-carousel-item>
            <a
              href="https://www.wch.cn/products/CH394.html?from=BBS_Banner"
              target="_blank"
            >
              <img src="https://img.wch.cn/20250210/01.png" alt="..." />
            </a>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="statement">公告：</div>
      <div class="posts">
        <el-row gutter="10">
          <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
            <div class="post-index">
              最新主题
              <ul>
                <li v-for="item in latestTopics" :key="item.id">
                  <router-link v-if="item.postType && item.postType === 'article'"
                    :to="{ path: '/article/'+item.userId+'/' + item.postId + '.html' }"
                  >
                    {{ item.postTitle }}
                  </router-link>
                  <router-link v-else
                    :to="{ path: '/thread-' + item.postId + '-1.html' }"
                  >
                    {{ item.postTitle }}
                  </router-link>
                </li>
              </ul>
            </div>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
            <div class="post-index">
              热帖
              <ul>
                <li v-for="item in hotTopics" :key="item.id">
                  <router-link
                    :to="{ path: '/thread-' + item.postId + '-1.html' }"
                  >
                    {{ item.postTitle }}
                  </router-link>
                </li>
              </ul>
            </div>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
            <div class="post-index">
              精华帖
              <ul>
                <li v-for="item in trendingTopics" :key="item.id">
                  <router-link
                    :to="{ path: '/thread-' + item.postId + '-1.html' }"
                  >
                    {{ item.postTitle }}
                  </router-link>
                </li>
              </ul>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-card>

    <div v-for="item in forumTree" :key="item.id">
      <ForumCard :values="item" />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import { getForumTree } from "@/service/forum";
import { getHomeData } from "@/service/post";
import ForumCard from "@/components/ForumCard";

export default {
  name: "HomeView",
  
  data() {
    return {
      forumTree: null,
      latestTopics: null,
      topTopics: null,
      trendingTopics: null,
    };
  },
  components: {
    ForumCard,
  },
  created() {
    this.fetchData();
  },

  methods: {
    fetchData() {
      this.$store.dispatch("app/setBreadcrumb", []);
      getForumTree()
        .then((response) => {
          console.info(response.data);
          this.forumTree = response.data;
        })
        .catch((error) => {
          console.error(error);
        });

      getHomeData()
        .then((response) => {
          this.latestTopics = response.data.latestTopics;
          this.hotTopics = response.data.hotTopics;
          this.trendingTopics = response.data.trendingTopics;
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>
<style lang="less">
.home-card {
  margin-bottom: 20px;

  .carousel_mobile {
    img {
      width: 100%;
      height: auto;
      display: block;
      margin: 0 auto;
    }

    .el-carousel__container {
      height: 100px !important;
    }
  }

  .el-card__header {
    padding: 0;
  }
  .statement {
    height: 30px;
    line-height: 30px;
    border-bottom: 1px dashed #dc0000;

    text-align: left;
  }

  .posts {
    margin-top: 10px;
    .post-index {
      text-align: left;
      font-weight: 700;
      height: 260px;
      margin-bottom: 15px;
      color: #1483dc;
      ul {
        padding-left: 0;
        margin-top: 10px;

        li {
          list-style: none;
          height: 20px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          a {
            color: #000;
            line-height: 20px;
            font-weight: 500;
          }
          a:hover {
            color: #dc0000;
          }
        }
      }
    }
  }
}
</style>
